module.exports = __webpack_public_path__ + "img/02.1a1da6e7.jpg";